import React, { Component } from 'react';

class IconChatMinimize extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                fill="none"
                viewBox="0 0 24 25"
            >
                <g fill="#fff" clipPath="url(#clip0_5701_22246)">
                    <path d="M22.707 7.708h-4.232l3.517-3.46 1.603-1.592a1.154 1.154 0 00.358-1.234 1.153 1.153 0 00-.83-.83 1.257 1.257 0 00-1.154.357l-3.09 2.964-2.077 2.122V1.768a1.327 1.327 0 00-.357-.934 1.153 1.153 0 00-.83-.323 1.153 1.153 0 00-1.154 1.257v7.035a1.155 1.155 0 001.292 1.28h7a1.304 1.304 0 001.218-.78c.057-.14.087-.29.086-.442a1.153 1.153 0 00-1.35-1.153zM8.314 14.916H1.279a1.425 1.425 0 00-.37 0 1.154 1.154 0 00-.899 1.28 1.153 1.153 0 001.153 1.061h4.325l-2.525 2.595-2.538 2.515a1.153 1.153 0 00-.369 1.245 1.153 1.153 0 00.83.819h.277a1.28 1.28 0 00.923-.404l5.132-5.132v4.279a1.153 1.153 0 001.154 1.257 1.152 1.152 0 00.83-.335c.235-.25.367-.58.369-.922v-7.058a1.153 1.153 0 00-1.257-1.2zM23.967 15.816a1.153 1.153 0 00-1.292-.9 1.153 1.153 0 00-1.05 1.153v5.26c0 .53-.218.749-.749.749h-5.224a1.153 1.153 0 00-1.28 1.153 1.152 1.152 0 00.334.842 1.326 1.326 0 00.946.37h5.293a2.996 2.996 0 003.01-3.022v-5.294c.016-.103.02-.208.012-.311zM8.394.512H2.882A2.998 2.998 0 00.01 3.464a1.153 1.153 0 102.306.07.611.611 0 01.692-.647h5.386a1.153 1.153 0 00.854-.357 1.154 1.154 0 00.346-.842 1.153 1.153 0 00-1.2-1.176zM1.19 7.373a1.153 1.153 0 00.841-.346 1.153 1.153 0 00.358-.841 1.153 1.153 0 10-1.154 1.153l-.046.034zM1.051 10.073h.288a1.153 1.153 0 001.05-1.154 1.153 1.153 0 00-.358-.853 1.153 1.153 0 00-.853-.346A1.153 1.153 0 00.025 8.873a1.153 1.153 0 001.026 1.2z"></path>
                </g>
                <defs>
                    <clipPath id="clip0_5701_22246">
                        <path
                            fill="#fff"
                            d="M0 0H24V24H0z"
                            transform="translate(0 .5)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconChatMinimize;